module.exports = __webpack_public_path__ + "img/option-certificate.c56130f5.png";